import { Grid, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'
import { ReferralBaseInfo } from '../../types/patientReferrals.types'
import { formatTAJ } from '../../../../../utils'
import { formatAddress } from '../../../../../utils/formatAddress'

interface ReferralDetailsStepProps {
  referralBaseInfo: ReferralBaseInfo
}
const ReferralPatientDetails: React.FC<ReferralDetailsStepProps> = ({
  referralBaseInfo,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Grid container>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.patient')}>
            <Typography variant="body2">
              {t('common:formattedNameFull', {
                title: referralBaseInfo.patient.title,
                firstName: referralBaseInfo.patient.firstName,
                lastName: referralBaseInfo.patient.lastName,
              })}
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.tajNumber')}>
            <Typography variant="body2">
              {formatTAJ(referralBaseInfo.patient.tajNumber)}
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.mothersName')}>
            <Typography variant="body2">
              {
                t('common:formattedName', {
                  firstName: referralBaseInfo.patient.motherFirstName,
                  lastName: referralBaseInfo.patient.motherLastName,
                }) as string
              }
            </Typography>
          </BoxWithLabel>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.birthDate')}>
            <Typography variant="body2">
              {t('common:dateFormatted', {
                date: referralBaseInfo.patient.birthDate,
              })}
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.birthPlace')}>
            <Typography variant="body2">
              {referralBaseInfo.patient.birthPlace}
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.address')}>
            <Typography variant="body2">
              {formatAddress(
                referralBaseInfo.patient.addressPostalCode,
                referralBaseInfo.patient.addressCity,
                referralBaseInfo.patient.addressStreet
              )}
            </Typography>
          </BoxWithLabel>
        </Grid>
      </Grid>
    </>
  )
}

export { ReferralPatientDetails }
